import cn from 'classnames';
import { PlateElement, type PlateElementProps } from 'platejs/react';

import styles from './BlockquoteElement.module.scss';

export function BlockquoteElement(props: PlateElementProps) {
	return <PlateElement as="blockquote" className={cn(styles.blockquote, props.className)} {...props} />;
}
